<template>
  <div class="d1" role="contentinfo">
    <div class="d1a"></div>
    <div class="d1b">
      <img class="img1" src="../assets/logo.png" @click="this.$router.push('/home');" alt="Mailbox with a hand reaching out of it." />
      <div class="d1b1">© Copyright: In Your Hands LLC</div>
      <div class="d1b2">Web Development by <span> <a class="d1b2a" href="#" @click="openLink('https://rexrothdev.com')">Rexroth Development LLC </a></span></div>
    </div>
    <div class="d1c"></div>
  </div>
</template>

<script>
  export default {
    name: 'footer',
    data() {
      return {
        isMobile: false,
      }
    },
    methods: {
            windowSize () {
        if (window.innerWidth <= 900) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
    },
    mounted() {
      this.windowSize();
      window.addEventListener('resize', this.windowSize);      
    },    
    beforeUnmount() {
      window.removeEventListener('resize', this.windowSize);
    }
  }
</script>

<style scoped>
  .d1 {
    display: flex;
    justify-content: space-evenly;
    background-color: v-bind(colorBlue2);
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .d1b {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    font-family: 'Akatab';    
  }
  .d1b1 {
    margin-bottom: 15px;
  }
  .d1b2a {
    color: white;
    text-decoration: underline;
  }
  .d1b2a:hover {
    color: blue;
    cursor: pointer;    
  }
  .img1 {
    width: 70px;
    border-radius: 10px;    
    margin-bottom: 20px;    
  }
  .img1:hover {
    transform: scale(1.2);
    cursor: pointer;
  }
@media only screen and (max-width: 900px) {
  .d1{
    font-size: 10px;
  }
}
</style>